export default "__VITE_ASSET__C7JT2JMS__"